import { render, staticRenderFns } from "./pos-ticket-table.vue?vue&type=template&id=67c95b92&scoped=true&"
import script from "./pos-ticket-table.ts?vue&type=script&lang=ts&"
export * from "./pos-ticket-table.ts?vue&type=script&lang=ts&"
import style0 from "./pos-ticket-table.scss?vue&type=style&index=0&id=67c95b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c95b92",
  null
  
)

export default component.exports